import type { FaqItem } from '@/data/faq';
import type { Brand, Category, Product } from '@/types/catalog';

export interface BusinessHour {
  days: string;
  hours: string;
}

export interface SiteSettings {
  site: {
    name: string;
    legalName: string;
    tagline: string;
    url: string;
    description: string;
    serviceArea: string;
    foundedYear: number;
  };
  contact: {
    whatsappNumber: string;
    whatsappDisplay: string;
    instagramHandle: string;
    instagramUrl: string;
    email: string;
  };
  businessHours: BusinessHour[];
  commerce: {
    showPrices: boolean;
    freeShippingThreshold: number;
    deliveryFee: number;
    maxQuantityPerItem: number;
  };
}

/** Tudo que o painel edita, numa estrutura só. */
export interface AdminContent {
  products: Product[];
  brands: Brand[];
  categories: Category[];
  faq: FaqItem[];
  settings: SiteSettings;
}

export type ContentKey = keyof AdminContent;

/** Caminho no repositório de cada parte — o que a API aceita gravar. */
export const CONTENT_PATHS: Record<ContentKey, string> = {
  products: 'src/content/products.json',
  brands: 'src/content/brands.json',
  categories: 'src/content/categories.json',
  faq: 'src/content/faq.json',
  settings: 'src/content/settings.json',
};

export const CONTENT_LABELS: Record<ContentKey, string> = {
  products: 'Produtos',
  brands: 'Marcas',
  categories: 'Categorias',
  faq: 'Perguntas frequentes',
  settings: 'Configurações',
};
